// extracted by mini-css-extract-plugin
export var closeButton = "_24-0";